<template>
  <div class="promo-list-desc">
    <div v-if="descriptionText && descriptionText.long.length">
      <slot name="title" />

      <p
        v-for="(line, i) in descriptionText.long"
        :key="'line-' + i"
      >
        <span
          v-show="showLine(i)"
          v-html="line"
        /><span v-if="isCollapsed && showLine(i)">..</span>
      </p>

      <button
        class="promo-list-desc__expand-btn"
        @click="setIsCollapsed(!isCollapsed)"
      >
        <Lang
          v-if="isCollapsed"
          by-key="see-more"
          capitalize-first
        />
        <Lang
          v-else
          by-key="see-less"
          capitalize-first
        />
      </button>
    </div>

    <SectionAtom
      v-else
      property="description"
      itemprop="description"
      :start-collapsed="true"
      :is-collapsable="true"
      :separator="false"
      :html="description"
    >
      <template #title>
        <slot name="title" />
      </template>
    </SectionAtom>
  </div>
</template>

<script lang="ts">
import SectionAtom from '../shared/Section.atom.vue'

import type { Location } from '~/core/ts/entity/Location'
import { Promotion } from '~/core/ts/entity/Promotion'
import { PromotionSmallDescriptionRepository } from '~/core/ts/repository/PromotionSmallDescriptionRepository'

export default defineNuxtComponent({
  components: {
    SectionAtom,
  },
  props: {
    promotion: {
      type: Object as PropType<Promotion>,
      default: () => null,
    },
    location: {
      type: Object as PropType<Location | null | undefined>,
      default: () => null,
    },
  },
  setup(props) {
    const isCollapsed = ref(true)

    function setIsCollapsed(value: boolean) {
      isCollapsed.value = value
    }

    const showLine = (index: number) => {
      if (index === 0) {
        return true
      }

      return !isCollapsed.value
    }

    const descriptionText = (() => {
      if (!props.promotion) {
        return { short: [], long: [] }
      }

      if (props.location) {
        return PromotionSmallDescriptionRepository.getLocalizedDescriptionBySlug(props.promotion.slug, props.location)
      }

      return PromotionSmallDescriptionRepository.getDescriptionBySlug(props.promotion.slug)
    })()

    const description = (() => {
      if (!props.promotion) {
        return ''
      }

      return props.promotion.description
    })()

    return {
      isCollapsed,
      setIsCollapsed,
      showLine,
      descriptionText,
      description,
    }
  },
})
</script>

<style lang="scss" scoped>
.promo-list-desc {
  @apply px-2;

  @screen lg {
    @apply px-0;
  }

  &__expand-btn {
    @apply underline;
  }

  p {
    @apply my-2;
  }
}
</style>
